import { http } from "@/utils/index";

export function getNewsHomeRecommend() {
  return http.request("get", "/news/homeRecommend", {
    params: {},
  });
}

export function getNews(params) {
  return http.request("get", "/news", {
    params,
  });
}

export function getNewsTags() {
  return http.request("get", "/tag", {});
}

export function getNewsDetails(id) {
  return http.request("get", "/news/" + id, {});
}

export function getNewsByTypeIds(ids, params) {
  return http.request("get", "/news/typeIds/" + ids.join(","), {
    params,
  });
}

export function getNewsContentNotEmpty(params) {
  return http.request("get", "/news/content", {
    params,
  });
}
